export enum ePlatforms
{
    EVM = 'EVM',
    // ETHEREUM = 'Ethereum',
    // BSC = 'BSC',
    // PULSECHAIN = 'PulseChain',
    // POLYGON = 'Polygon'
}
export enum eBlockchains
{
    ETHEREUM = 'Ethereum',
    KOVAN = 'Kovan',
    ROPSTEN = 'Ropsten',
    BSC = 'BSC',
    PULSECHAIN = 'PulseChain',
    POLYGON = 'Polygon'
}

export enum eChainId
{
    ETHEREUM_MAINNET = 1,
    ETHEREUM_KOVAN = 42,
    ETHEREUM_ROPSTEN = 3,
    BSC_MAINNET = 56,
    BSC_TESTNET = 97,
    POLYGON_MAINNET = 137,
    POLYGON_AMOY = 80002,
    PULSECHAIN_TESTNET = 943,
    ETHEREUM_SEPOLIA = 11155111,
    PULSECHAIN_MAINNET = 369,
    AVALACHE_MAINNET = 43114,
    AVALACHE_TESTNET = 43113,
}

export const NETWORK_NAMES: Partial<Record<eChainId, string>> = {
    [ eChainId.ETHEREUM_MAINNET ]: 'mainnet',
    [ eChainId.ETHEREUM_KOVAN ]: 'kovan',
    [ eChainId.BSC_MAINNET ]: 'mainnet',
    [ eChainId.BSC_TESTNET ]: 'testnet',
    [ eChainId.POLYGON_MAINNET ]: 'mainnet',
    [ eChainId.POLYGON_AMOY ]: 'testnet',
    // [eChainId.PULSECHAIN_MAINNET]: 'mainnet',
    [ eChainId.PULSECHAIN_TESTNET ]: 'testnet',
};

export class Networks
{
    public static getPlatformByChainId(_chainId: number): ePlatforms
    {
        switch (_chainId)
        {
            case eChainId.ETHEREUM_MAINNET:
            case eChainId.ETHEREUM_KOVAN:
            case eChainId.ETHEREUM_ROPSTEN:
            case eChainId.ETHEREUM_SEPOLIA:
            // return ePlatforms.ETHEREUM;
            case eChainId.BSC_MAINNET:
            case eChainId.BSC_TESTNET:
            // return ePlatforms.BSC;
            case eChainId.POLYGON_MAINNET:
            case eChainId.POLYGON_AMOY:
            // return ePlatforms.POLYGON;
            case eChainId.PULSECHAIN_TESTNET:
                // case eChainId.PULSECHAIN_MAINNET:
                return ePlatforms.EVM;
        }
    }
}
